import type {PublicMethodUtils} from '@wix/document-services-types'
import type {ExternalComponentsPublicAPI} from '@wix/document-services-public-types'
import {externalComponents} from '@wix/document-services-implementation'
import type {PublicModuleDeclaration} from '../../documentServicesInitialisation'

export default function (publicMethodUtils: PublicMethodUtils): PublicModuleDeclaration<ExternalComponentsPublicAPI> {
    return {
        methods: {
            externalComponents: {
                setUserConsent: publicMethodUtils.defineAction(externalComponents.setUserConsent),
                getUserConsent: publicMethodUtils.defineGetter(externalComponents.getUserConsent),
                showLoader: publicMethodUtils.defineAction(externalComponents.showLoader)
            }
        }
    }
}
